const initialState = {
  course: null,
  base: null
} as any;

const template = (state = initialState, action: any) => {
  switch (action.type) {
    case 'RECEIVE_COURSE_TEMPLATE': {
      return {
        ...state,
        course: { ...action.courseTemplate }
      };
    }
    case 'RECEIVE_INITIAL_TEMPLATE':
      return {
        ...state,
        base: {
          ...action.template,
          title: action.title,
          subdomain: action.subdomain,
          login_page: action.login_page,
          support_external_url: action.support_external_url
        }
      };
    case 'CLEAN_COURSE_TEMPLATE':
      return {
        ...state,
        course: null
      };
    default:
      return state;
  }
};

export default template;
